import FieldCheckbox from "../checkbox/checkbox"
import FieldConfig from "../../../proto/field-config"
import FieldToggle_ManagementPreview from "./render/management-preview"
import FieldToggle_View from "./render/view"
import FieldToggle_ViewSmall from "./render/view-small"
import FieldToggle_InlineEditable from "./render/inline-editable"
import FieldToggle_FormElement from "./render/form-element"
import FieldToggle_FormElementView from "./render/form-element-view"
import {GROUP_BOOL} from "../../../../gd/const/fields/field2-groups"
import {FieldFilterType} from "../../../proto/types"
import ImportFromCSVModule from "../../../../gd-modules/import-from-csv/import-from-csv-module"
import normalizeBoolean from "../../../import/normalize/normalize-boolean"
import CustomFieldsV1 from "../../../../gd/const/fields/custom-fields-v1"
import SessionCustomField from "../../../../model2/custom-field/session-custom-field"
import {FieldType} from "../../../field-type"
import FieldToggle_Editable from "./render/editable/editable"
import FieldToggle_TableCell from "./render/table/table-cell"
import FieldToggle_ManagementFormCFV1 from "./render/management-form-cfv1"
import FieldTToggle_ViewProperty from "./render/property"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"
import FieldToggle_TableCellCalculated from "./render/table/calculated/table-cell-calculated"
import FieldToggle_AggregateCell from "./render/aggregate/aggregate-cell";
import FieldToggle_BoardAggregate from "./render/aggregate/board-aggregate";

export default class FieldToggle extends FieldCheckbox {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config);

        this.typeInteger        = CustomFieldsV1.type.TOGGLE
        this.typeLabel          = "Toggle"
        this.typeGroup          = GROUP_BOOL
        this.typeDescription    = "Form toggle field"
        this.filterType         = FieldFilterType.BOOLEAN;

        this.icon               = 'i5-toggle';

        this.isSearchable       = false;

        this.hasCalculatedValues                    = true

        // this.size               = _.get(config, 'size', 16) // Size ne sovpodaet s Checkbox size

        this.renderComponents.view                  = FieldToggle_View
        this.renderComponents.viewProperty          = FieldTToggle_ViewProperty
        this.renderComponents.viewSmall             = FieldToggle_ViewSmall

        this.renderComponents.editable              = FieldToggle_Editable
        this.renderComponents.tableCell             = FieldToggle_TableCell
        this.renderComponents.tableCellCalculated   = FieldToggle_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldToggle_AggregateCell
        this.renderComponents.boardAggregate        = FieldToggle_BoardAggregate
        this.renderComponents.inlineEditable        = FieldToggle_InlineEditable

        this.renderComponents.formElement           = FieldToggle_FormElement
        this.renderComponents.formElementView       = FieldToggle_FormElementView

        this.renderComponents.managementPreview     = FieldToggle_ManagementPreview
        this.renderComponents.managementFormCFV1    = FieldToggle_ManagementFormCFV1

    }

    static initFromCustomFieldV1(customFieldV1:SessionCustomField) {
        return new FieldToggle({
            fieldId         : customFieldV1.id,
            type            : FieldType.TOGGLE,
            fieldParams     : customFieldV1.params,
            fieldAccess     : customFieldV1.access
        })
    }

    sortValue(value:any) { return value }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeBoolean(value)
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.CHECKED_TOTAL,
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.CHECKED_TOTAL
    }
}
